import w from "./objectWithoutPropertiesLoose3.mjs";
import o from "./extends3.mjs";
import * as W from "react";
import { clsx as q } from "./clsx.mjs";
import { ArrowLeftIcon as E, ArrowRightIcon as F } from "./index243.mjs";
import { getPickersArrowSwitcherUtilityClass as J } from "./pickersArrowSwitcherClasses.mjs";
import { jsxs as K, jsx as i } from "react/jsx-runtime";
import P from "./styled.mjs";
import O from "./IconButton.mjs";
import Q from "./useTheme.mjs";
import V from "./useThemeProps.mjs";
import { useSlotProps as d } from "./useSlotProps.mjs";
import X from "./Typography.mjs";
import Y from "./composeClasses.mjs";
const Z = ["children", "className", "slots", "slotProps", "isNextDisabled", "isNextHidden", "onGoToNext", "nextLabel", "isPreviousDisabled", "isPreviousHidden", "onGoToPrevious", "previousLabel"], oo = ["ownerState"], eo = ["ownerState"], to = P("div", {
  name: "MuiPickersArrowSwitcher",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({
  display: "flex"
}), ro = P("div", {
  name: "MuiPickersArrowSwitcher",
  slot: "Spacer",
  overridesResolver: (e, t) => t.spacer
})(({
  theme: e
}) => ({
  width: e.spacing(3)
})), N = P(O, {
  name: "MuiPickersArrowSwitcher",
  slot: "Button",
  overridesResolver: (e, t) => t.button
})(({
  ownerState: e
}) => o({}, e.hidden && {
  visibility: "hidden"
})), so = (e) => {
  const {
    classes: t
  } = e;
  return Y({
    root: ["root"],
    spacer: ["spacer"],
    button: ["button"]
  }, J, t);
}, fo = /* @__PURE__ */ W.forwardRef(function(t, h) {
  var v, b, S, f;
  const x = Q().direction === "rtl", p = V({
    props: t,
    name: "MuiPickersArrowSwitcher"
  }), {
    children: I,
    className: k,
    slots: r,
    slotProps: s,
    isNextDisabled: y,
    isNextHidden: _,
    onGoToNext: R,
    nextLabel: D,
    isPreviousDisabled: H,
    isPreviousHidden: L,
    onGoToPrevious: C,
    previousLabel: M
  } = p, z = w(p, Z), n = p, a = so(n), l = {
    isDisabled: y,
    isHidden: _,
    goTo: R,
    label: D
  }, c = {
    isDisabled: H,
    isHidden: L,
    goTo: C,
    label: M
  }, A = (v = r?.previousIconButton) != null ? v : N, G = d({
    elementType: A,
    externalSlotProps: s?.previousIconButton,
    additionalProps: {
      size: "medium",
      title: c.label,
      "aria-label": c.label,
      disabled: c.isDisabled,
      edge: "end",
      onClick: c.goTo
    },
    ownerState: o({}, n, {
      hidden: c.isHidden
    }),
    className: a.button
  }), T = (b = r?.nextIconButton) != null ? b : N, $ = d({
    elementType: T,
    externalSlotProps: s?.nextIconButton,
    additionalProps: {
      size: "medium",
      title: l.label,
      "aria-label": l.label,
      disabled: l.isDisabled,
      edge: "start",
      onClick: l.goTo
    },
    ownerState: o({}, n, {
      hidden: l.isHidden
    }),
    className: a.button
  }), u = (S = r?.leftArrowIcon) != null ? S : E, j = d({
    elementType: u,
    externalSlotProps: s?.leftArrowIcon,
    additionalProps: {
      fontSize: "inherit"
    },
    ownerState: void 0
  }), g = w(j, oo), m = (f = r?.rightArrowIcon) != null ? f : F, U = d({
    elementType: m,
    externalSlotProps: s?.rightArrowIcon,
    additionalProps: {
      fontSize: "inherit"
    },
    ownerState: void 0
  }), B = w(U, eo);
  return /* @__PURE__ */ K(to, o({
    ref: h,
    className: q(a.root, k),
    ownerState: n
  }, z, {
    children: [/* @__PURE__ */ i(A, o({}, G, {
      children: x ? /* @__PURE__ */ i(m, o({}, B)) : /* @__PURE__ */ i(u, o({}, g))
    })), I ? /* @__PURE__ */ i(X, {
      variant: "subtitle1",
      component: "span",
      children: I
    }) : /* @__PURE__ */ i(ro, {
      className: a.spacer,
      ownerState: n
    }), /* @__PURE__ */ i(T, o({}, $, {
      children: x ? /* @__PURE__ */ i(u, o({}, g)) : /* @__PURE__ */ i(m, o({}, B))
    }))]
  }));
});
export {
  fo as PickersArrowSwitcher
};
//# sourceMappingURL=PickersArrowSwitcher.mjs.map
